import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { SelectMobileDialogComponent } from './select-mobile-dialog/select-mobile-dialog.component';

@Component({
  selector: 'select-mobile',
  templateUrl: './select-mobile.component.html',
  styleUrls: ['./select-mobile.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: SelectMobileComponent,
      multi: true
    }
  ]
})
export class SelectMobileComponent implements OnInit {

  // inputs
  @Input() placeholder: string;
  @Input() displayFieldName: string;
  @Input() defaultLabel: any;
  @Input() defaultValue: any;
  @Input() valueFieldName: string;
  @Input() records: Array<any>;
  
  updatedRecords: Array<any> = [];
  dialogRef = null;
  displayText: string;
  public value: any;
  public changed: (value: string) => void;
  public touched: () => void;

  constructor(
    public changeDetector: ChangeDetectorRef,
    public dialog: MatDialog,
    private _fb: UntypedFormBuilder
    ) { }

  // from group
  form: UntypedFormGroup = this._fb.group({
    inputCtrl: [null],
    optionsCtrl: [null]
  });

  getInputLabel(): string {
    return this.value ? this.value[this.displayFieldName] : '';
  }

  ngOnInit(): void {
    this.updateRecords();
    this.changeDetector.detectChanges();
    this.setValueChangeEvents();
  }

  openMenu(): void {
    this.openDialog();
  }

  openDialog(): void {
    this.dialogRef = this.dialog.open(SelectMobileDialogComponent, {
      autoFocus: false,
      panelClass: 'mobile-dialog-container',
      width: '575px',
      maxWidth: '600px',
      data: {
        displayFieldName: this.displayFieldName,
        valueFieldName: this.valueFieldName,
        records: this.updatedRecords,
        form: this.form
      }
    });
  }

  setValueChangeEvents(): void {
    this.form.controls.optionsCtrl.valueChanges
      .subscribe( (value) => {
        this.onValueChange(value);
      });
  }

  updateRecords(): void {
    // clone array into "updatedRecords"
    this.updatedRecords = this.records.map(x => x);

    if (this.defaultLabel) {
      let defaultItem = {};
      defaultItem[this.valueFieldName] = this.defaultValue;
      defaultItem[this.displayFieldName] = this.defaultLabel;
      this.updatedRecords.unshift(defaultItem);
    }
  }

  onValueChange(value: any) {
    this.value = value;
    this.changed(this.value);
  }

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: (value: any) => void): void {
    this.changed = fn;
  }

  registerOnTouched(fn: () => void) {
    this.touched = fn;
  }
}
